import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

import VimeoPlayer from "@vimeo/player";

import { getUrlParameter, hasUrlParameter, forceInt, getCurrenLocaleObj } from "../functions";

$(function() {
    const currenLocaleObj = getCurrenLocaleObj();

    function getVideoStorageKey() {
        let videoStorageKey = null;

        const $courseComponentId = $('#CourseNotesForm_CourseNotesForm_CourseComponentID');
        if ($courseComponentId.length) {
            const courseComponentId = forceInt($courseComponentId.val());
            if (courseComponentId) {
                videoStorageKey = 'HpaCourseVideo' + courseComponentId;
            }
        }

        return videoStorageKey;
    }

    // VIP page: the WYSIWYG content contains a placeholder enroll button; fill it with the real button's HTML
    // (includes the correct part payment price)
    const $vipContentBtnEnroll = $('.js-vip-content-btn-enroll');
    if ($vipContentBtnEnroll.length) {
        // the WYSIWYG placeholder also has .btn.js-purchaseLink, so it must be excluded from the source button lookup
        const $vipPurchaseLink = $('.btn.js-purchaseLink').not('.js-vip-content-btn-enroll').first();
        if ($vipPurchaseLink.length) {
            $vipContentBtnEnroll.html($vipPurchaseLink.html());
        }
    }

    const $buttonWrapper = $('.js-btnWrapperSticky');
    if ($buttonWrapper.length) {
        const heightFromTop = $buttonWrapper.offset().top,
            height = $buttonWrapper.outerHeight(),
            $btnStickyPopupPoint = $('#btn-sticky-popup-point');
        // console.log(heightFromTop, height);
        $(window).on('scroll', function() {
            if ($('.VIPSignupPage').length) { //  || $('.VIPSignupPage_tvar98').length
                // always sticky
                // I have hardecoded the class btn-sticky to the btn-wrapper div for VIP pages
                return;
            }
            if ($btnStickyPopupPoint.length) {
                const btnStickyPopupPointHeightFromTop = $btnStickyPopupPoint.offset().top;
                // console.log($(window).scrollTop(), btnStickyPopupPointHeightFromTop);
                if ($(window).scrollTop() > btnStickyPopupPointHeightFromTop) {
                    $buttonWrapper.addClass('btn-sticky');
                } else {
                    $buttonWrapper.removeClass('btn-sticky');
                }
            } else {
                // console.log($(window).scrollTop(), heightFromTop);
                if ($(window).scrollTop() > (heightFromTop + height)) {
                    $buttonWrapper.addClass('btn-sticky');
                } else {
                    $buttonWrapper.removeClass('btn-sticky');
                }
            }
        });
    }

    if ($('.popover-trigger').length) {
        $('.popover-trigger').popover();
        $(document).on('click', function(e) {
            if (!$(e.target).hasClass('popover-trigger')) {
                if ($('.popover').length) {
                    $('.popover').siblings('.popover-trigger').trigger('click'); // remove the popup field
                }
            }
        });
    }

    $("#course-filter").on("selectmenuselect", function(event, ui) {
        $.ajax({
            type: "GET",
            url: $(self).data("url"),
            dataType: "html",
            data: $("#CourseFilterForm").serializeArray(),
            success: function(data) {
                $(".course-row").remove();
                $("#CoursesContainer").append(data);

                $(".equal-height").each(function() {
                    var highestBox = 0;
                    $(".equal", this).each(function() {
                        if ($(this).outerHeight() > highestBox) {
                            highestBox = $(this).outerHeight();
                        }
                    });
                    $(".equal", this).height(highestBox);
                });
            }
        });
    });

    $("#CourseFilterForm").on("submit", function(e) {
        e.preventDefault();
        $.ajax({
            type: "GET",
            url: $(self).data("url"),
            dataType: "html",
            data: $("#CourseFilterForm").serializeArray(),
            success: function(data) {
                $(".course-row").remove();
                $("#CoursesContainer").append(data);

                $(".equal-height").each(function() {
                    var highestBox = 0;
                    $(".equal", this).each(function() {
                        if ($(this).outerHeight() > highestBox) {
                            highestBox = $(this).outerHeight();
                        }
                    });
                    $(".equal", this).height(highestBox);
                });
            }
        });
    });

    $("body").on("touch click", ".video-trigger", function(e) {
        e.preventDefault();

        const $this = $(this);
        var triggered = $(this).attr("data-triggered");
        if (triggered) {
            return false;
        }
        var vimeoID = $(this).attr("data-vimeoID");
        // var vimeoVideoStartTime = parseInt($(this).data('vimeo-video-start-time'));
        var vimeoVideoStartTime = parseInt(getUrlParameter('vvst'));
        if (isNaN(vimeoVideoStartTime)) vimeoVideoStartTime = 0;
        var vimeoVideoStartTimeUrlFragment = "";
        if (vimeoVideoStartTime > 0) {
            vimeoVideoStartTimeUrlFragment = "#t=" + vimeoVideoStartTime + "s";
        }
        var embedWidth = $(this).attr("data-embedWidth");
        var embedHeight = $(this).attr("data-embedHeight");
        var inLineStyle = "";
        if (embedWidth && embedHeight) {
            inLineStyle = ' style="width:' + embedWidth + "px;height:" + embedHeight + 'px;"';
        }

        var nextVideoButton = $('#btnNextComponent');
        var nextVideoUrl = '';
        if (nextVideoButton.length) {
            nextVideoUrl = nextVideoButton.attr('href');
        }

        $this.css('background-image', 'none');
        $this.attr('data-triggered', 'true');
        $this.html('');

        let vimeo = false;
        const courseId = forceInt($this.data('course-id'));

        const altPlayerId = '#vimeo-id-' + vimeoID + (courseId ? '-' + courseId : ''),
            $altPlayer = $(altPlayerId);
        if ($altPlayer.length) {
            console.log('Vimeo new');
            const options = {
                id: vimeoID,
                autoplay: true, // 'autoplay' always needs to be set to 'true' because when they click on our play button the embedded video needs to play automatically
                title: false,
                byline: false,
                portrait: false,
                color: 'ff9933',
                fullscreen: true,
                transparent: false,
                playsinline: false,
                audiotrack: 'main', // From https://developer.vimeo.com/player/sdk/embed option 'audiotrack' "Set this value to main to select the original audio for the video. If there is no matching track, the player ignores this value."
                // play_button_position: 'center',
                // responsive: true,
            };
            // https://developer.vimeo.com/player/sdk/embed
            // Set this value to main to select the original audio for the video. If there is no matching track, the player ignores this value.

            if (currenLocaleObj.code2 !== '' && currenLocaleObj.code2 !== 'en') { // If it's 'en' then we want to use the default which is 'main'
                options.audiotrack = currenLocaleObj.code2;
            }
            if (vimeoVideoStartTime > 0) {
                options.start_time = vimeoVideoStartTime;
            }

            if ($('.DashboardPage').length) {
                if (!options.start_time) {
                    const data = JSON.parse(localStorage.getItem(getVideoStorageKey()) || '{}');
                    if (data.videoSeconds) {
                        options.start_time = forceInt(data.videoSeconds);
                    }
                }
            }

            // console.log({ code2: currenLocaleObj.code2, audiotrack: options.audiotrack, typeofAutoplayVideo: typeof autoplayVideo, autoplayVideo, vimeoVideoStartTime } );
            // console.log(options);
            vimeo = new VimeoPlayer($altPlayer, options);
            if (!$('.DashboardPage').length) { // Don't run on the Dashboard CourseComponent pages
                vimeo.on('loaded', () => {
                    $altPlayer.fitVids(); // This caused the on events not to work on the Dashboard CourseComponent pages. This is needed on CourseSales pages
                });
            }
        } else {
            console.log('Vimeo old');
            var iframeId = 'vimeo-iframe-' + vimeoID;
            //"?autoplay=1&title=0&byline=0&portrait=0&color=ff9933&fullscreen=1&transparent=0" +
            //webkitAllowFullScreen mozallowfullscreen allowFullScreen

            $(this).html(
                '<iframe src="https://player.vimeo.com/video/' + vimeoID + '?autoplay=1&title=0&byline=0&portrait=0&color=ff9933&fullscreen=1&transparent=0&playsinline=0' + vimeoVideoStartTimeUrlFragment + '"' +
                ' frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen ' +
                inLineStyle +
                ' id="' + iframeId + '"' +
                ' allow="autoplay"' +
                ' playsinline="false"' +
                //' color="ff9933"' +
                //' muted="true"' +
                //' title="false"' +
                //' byline="false"' +
                //' data-vimeo-fullscreen="true"' +
                " ></iframe>"
            );
            // playsinline - default "true" - Play video inline on mobile devices, to automatically go fullscreen on playback set this parameter to false.

            $(this).fitVids();

            // https://github.com/vimeo/player.js
            vimeo = new VimeoPlayer(iframeId);
        }

        if (nextVideoButton.length && vimeo) {
            vimeo.on('ended', () => {
                const videoStorageKey = getVideoStorageKey();
                if (videoStorageKey) localStorage.removeItem(videoStorageKey);

                if (autoplayVideo) {
                    $('#btnNextComponent').trigger('click');
                }
            });
        }

        const promotionalWebinarRecordingPage = $('.WebinarPromotional--recording'),
            promotionalWebinarRecordingPageButton = $('.promotional-webinar-recording-page-button');
        if (promotionalWebinarRecordingPageButton.length && vimeo) {
            let showButtonTime = parseInt(promotionalWebinarRecordingPageButton.data('show-button-time')),
                timeoutSeconds = 3000;

            if (isNaN(showButtonTime)) showButtonTime = 0;

            if (showButtonTime > 0) {
                const pwrpShowButton = function() {
                    vimeo.getCurrentTime().then(function(seconds) {
                        // seconds = the current playback position
                        if (seconds >= showButtonTime) {
                            promotionalWebinarRecordingPageButton.show();
                        } else {
                            setTimeout(pwrpShowButton, timeoutSeconds);
                        }
                    }).catch(function(error) {
                        // an error occurred
                    });
                };
                setTimeout(pwrpShowButton, timeoutSeconds);
            }
        }

        const $courseTranscript = $('#course-transcript'),
            courseTranscriptParts = [],
            courseTranscriptHighlightClassName = 'selected';
        let $courseTranscriptSegments = false;
        if ($courseTranscript.length) {
            $courseTranscriptSegments = $courseTranscript.find('span');
            $courseTranscriptSegments.each(function() {
                const $this = $(this);

                let seconds = parseInt($this.data('seconds'));
                if (isNaN(seconds)) seconds = 0;

                courseTranscriptParts.push({
                    element: $this,
                    seconds: parseInt($this.data('seconds')),
                });
            });

            // vimeo.on('cuechange', function(obj) {
            //     $courseTranscriptSegments.removeClass(highlightClassName);
            //
            //     let text = obj.cues[0].text;
            //     text = text.replace("\n", ' ');
            //     const id = btoa(text);
            //
            //     $courseTranscript.find('span[data-id="' + id + '"]').addClass(highlightClassName);
            //
            // });
        }

        if (vimeo) {
            let lastVideoSecondsSave = 0;
            // need to run this code even when there is no course transcript
            // so that the timestamp is available for course notes
            vimeo.on('timeupdate', (obj) => {
                const seconds = forceInt(obj.seconds);

                if ($('.DashboardPage').length) {
                    const videoStorageKey = getVideoStorageKey();
                    if (videoStorageKey) {
                        const now = Date.now();
                        if ((now - lastVideoSecondsSave) > 3000) {
                            const data = JSON.parse(localStorage.getItem(videoStorageKey) || '{}');
                            data.videoSeconds = seconds;
                            localStorage.setItem(videoStorageKey, JSON.stringify(data));
                            lastVideoSecondsSave = now;
                        }
                    }
                }

                window.currentVideoSeconds = seconds;

                if ($courseTranscript.length) {
                    const part = courseTranscriptParts.find(part => part.seconds === seconds);
                    if (part) {
                        const $tr = part.element.parents('tr');
                        $courseTranscriptSegments.removeClass(courseTranscriptHighlightClassName);
                        part.element.addClass(courseTranscriptHighlightClassName);
                        $courseTranscript.animate({
                            scrollTop: $courseTranscript.scrollTop() + $tr.position().top - 40
                        });
                    }
                }
            });
        }

    });


    if ($('.course-info .video-trigger').length) {
        // If the URL has vvst GET param (which is the time in seconds the video should play from) then the attribute data-vimeo-video-start-time will be set to that value and we should autoplay the video
        // This is used for incorrect Quiz answers and Archived webinars timestamps
        if (hasUrlParameter('vvst')) {
            autoplayVideo = 1;
        }

        // This is the auto play feature
        if (autoplayVideo) {
            $('.course-info .video-trigger').trigger('click');
        }
    }

    $('[data-toggle-switch="autoplay"]').on('change', function(event, ui) {
        var $this = $(this),
            autoplay = ($this.is(':checked') ? 1 : 0);

        autoplayVideo = autoplay;

        $.ajax({
            type: "GET",
            url: currenLocaleObj.urlPrefix + "/dashboard/AutoplayVideo/" + autoplay,
            dataType: "json",
            success: function(data) {
                //console.log(data);
            }
        });
    });

    $('#btnNextComponent').on('touch click', function(e) {
        e.preventDefault();

        var $this = $(this),
            componetID = $this.data('componentid');

        $this.attr('disabled', 'true');
        $this.text(hpaTranslatedtext.courses.loadingText); // Loading...

        $.ajax({
            type: 'GET',
            url: currenLocaleObj.urlPrefix + '/dashboard/Watched/' + componetID,
            dataType: 'json',
            complete: function(data) {
                //console.log(data);
                // Successful watch signal
                window.location.href = $this.attr('href');
            }
        });
    });

    // TODO Don't think this is being used
    $(".trigger-course-video").on("touch click", function() {
        $.ajax({
            type: "POST",
            url: window.location.protocol + "//" + window.location.hostname + window.location.pathname + "/Watched",
            dataType: "json",
            success: function(data) {
                switch (data.status) {
                    case 200:
                        // Successful watch signal
                        console.log("This video has been watched.");
                        break;
                }
            }
        });
    });

    $('body').on('click touch', '.courses-info-box-wrapper .close-x', function() {
        $(this).parent().hide();
    });

    // VIP Accordions
    let openAccordionsCount = 0;

    const accordionFunction = (accordion) => {
        const $accordion = $(accordion);
        const $heading = $accordion.find('.accordion__title');
        const $contentWrap = $accordion.find('.accordion__content-wrap');
        const originalHeight = $contentWrap[0].scrollHeight;

        $contentWrap.css('height', '0');

        $heading.on('click', function() {
            const originalHeight = $contentWrap[0].scrollHeight;

            if ($accordion.hasClass('accordion__active')) {
                $accordion.removeClass('accordion__active');
                $contentWrap.css('height', '0');
                openAccordionsCount--;
            } else {
                $accordion.addClass('accordion__active');
                $contentWrap.css('height', `${originalHeight}px`);
                openAccordionsCount++;
            }

            updateExpandCollapseButtonState();
        });
    };

    $('.accordion').each(function() {
        accordionFunction(this);
    });

    $('#opti_expand_all a').on('click', function() {
        if (openAccordionsCount === 8) {
            $('.accordion').each(function() {
                const $accordion = $(this);
                const $contentWrap = $accordion.find('.accordion__content-wrap');

                if ($contentWrap.length === 0) return;

                $accordion.removeClass('accordion__active');
                $contentWrap.css('height', '0');
            });
            openAccordionsCount = 0;
            $(this).text(hpaTranslatedtext.courses.expandAll); // Expand All
        } else {
            $('.accordion').each(function() {
                const $accordion = $(this);
                const $contentWrap = $accordion.find('.accordion__content-wrap');
                const originalHeight = $contentWrap[0].scrollHeight;

                if ($contentWrap.length === 0) return;

                $accordion.addClass('accordion__active');
                $contentWrap.css('height', `${originalHeight}px`);
            });
            openAccordionsCount = 8;
            $(this).text(hpaTranslatedtext.courses.collapseAll); // Collapse All
        }
    });

    function updateExpandCollapseButtonState() {
        if (openAccordionsCount === 8) {
            $('#opti_expand_all a').text(hpaTranslatedtext.courses.collapseAll); // Collapse All
        } else {
            $('#opti_expand_all a').text(hpaTranslatedtext.courses.expandAll); // Expand All
        }
    }

    const $courseEntryPage = $('.CourseEntry');
    if ($courseEntryPage.length) {
        function initializeCourseVideo() {

            const $courseEntryContent = $('.course-entry-content'),
                $videoMask = $('.video-mask');

            if ($courseEntryContent.length && $videoMask.length) {
                const $firstPInContent = $courseEntryContent.find('p').first();
                if ($firstPInContent.length) {
                    $firstPInContent.after($videoMask);

                    function adjustVideoMaskSize() {
                        let $wrapper = $videoMask.find('.fluid-width-video-wrapper');
                        let $iframe = $videoMask.find('iframe');
                        let $videoTrigger = $videoMask.find('.video-trigger');

                        if ($videoTrigger.length) {
                            let videoWidth = $videoMask.width();
                            let videoHeight = videoWidth * 9 / 16;
                            $videoTrigger.css('height', videoHeight + "px");
                        }

                        if ($wrapper.length) {
                            $wrapper.css('padding-top', "56.25%");
                        }

                        if ($iframe.length) {
                            $iframe.css({
                                'width': '100%',
                                'height': '100%'
                            }).attr({
                                'scrolling': 'no',
                                'frameborder': '0'
                            });
                        }
                    }

                    adjustVideoMaskSize();
                    $(window).on('resize', adjustVideoMaskSize);

                    $videoMask.css({
                        'margin-top': '20px',
                        'margin-bottom': '20px'
                    });

                    let observer = new MutationObserver(() => {
                        let $iframe = $videoMask.find('iframe');
                        if ($iframe.length) {
                            adjustVideoMaskSize();
                        }
                    });

                    observer.observe($videoMask[0], { childList: true, subtree: true });
                }
            }

            $videoMask.css('display', 'block');
        }

        initializeCourseVideo();
    } // if $courseEntryPage.length
});



// WEBPACK FOOTER //
// ./js/modules/courses.js